import React from 'react';
//import APIBalance from './APIBalance';
//import RegistrationWizard from './momoregister';

import {RequisitionListPage,RequisitionItemDialog} from './forms';
import {RequisitionAIDraftPage,RequisitionEditPage} from './forms';
import {ReviewQueuePage,ReviewWorkspacePage,FormsAnalyticsPage} from './forms';

import {ActivityListPage,ActivityDriverMappingPage} from './activity';
import {ActivityPlanPage,ActivityEditPage} from './activity';
import {ActivityOutputPage,ActivityAnalyticsPage} from './activity';

//import {ObjectiveContractBuilder} from './kpis';
import {BudgetAllocationWorkbench} from './activitybudget';
import {ActivityMapWorkbench} from './activitymap';

export const forms:any = {
  //customer: <RegistrationWizard />,
  requisition: <RequisitionAIDraftPage />,
};

export const pages:any = {
  // customer: {
  //   add:<RegistrationWizard />,
  // },
  requisition: {
    add:<RequisitionAIDraftPage />,
    generate:<RequisitionAIDraftPage />,
    edit:<RequisitionEditPage />,
    view:<RequisitionItemDialog />,
    review:<ReviewQueuePage />,
    process:<ReviewWorkspacePage />,
    analyze:<FormsAnalyticsPage />,
  },
  activity: {
    add:<ActivityListPage />,
    plan:<ActivityPlanPage />,
    edit:<ActivityEditPage />,
    map:<ActivityDriverMappingPage />,
    output:<ActivityOutputPage />,
    process:<ReviewWorkspacePage />,
    analyze:<ActivityAnalyticsPage />,
  },
  // objectivecontract: {
  //   add: <ObjectiveContractBuilder />,
  // },
  budgetallocation: {
    add: <BudgetAllocationWorkbench />,
  },
  activitymap: {
    add: <ActivityMapWorkbench />,
  }

};